const ParallaxBannerSection = () => {
    return (
      <section
        className="h-[300px] bg-fixed bg-center bg-cover flex items-center justify-center"
        style={{ backgroundImage: "url('/images/banner2.png')" }}
      >
      </section>
    );
  };
  
  export default ParallaxBannerSection;
  